import { pxToEm } from 'util/pxToEm';
import { LogoIcon } from 'components/icons';
import { Box, styled, Typography, useTheme } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CampusLushLogoProps {
  logoVariant?: 'default' | 'white' | 'primary';
  className?: string;
}

export const CampusLushLogo = styled(
  ({
    logoVariant = 'default',
    className,
  }: CampusLushLogoProps): ReactElement => {
    const theme = useTheme();

    return (
      <Box
        className={className}
        display="flex"
        alignItems="center"
        lineHeight={0}
      >
        <Box
          className="CampusLushLogo-logo"
          sx={{
            marginRight: 5,
            marginBottom: 2,
            fontSize: pxToEm(30),
          }}
        >
          <LogoIcon
            color={
              logoVariant === 'primary'
                ? theme.palette.primary.main
                : logoVariant === 'white'
                ? '#fff'
                : undefined
            }
          />
        </Box>
        <Typography
          className="CampusLushLogo-text"
          sx={{
            fontFamily: 'Auro',
            fontWeight: 600,
            fontSize: pxToEm(24),
            color: '#fff',
            WebkitPrintColorAdjust: 'exact',
          }}
        >
          CampusLush
        </Typography>
      </Box>
    );
  },
)``;
